import { useTranslation } from 'react-i18next';
import React, { useContext } from "react";
import { PageHeader } from "./PageHeader";
import { DataBox } from "./DataBox";
import { AdvancedPrint } from "./AdvancedPrint";
import { MyContext } from "@/store/myContext";

export default () => {
    
const { t } = useTranslation();
const { state } = useContext(MyContext);

    return (
        <>
            {state.activeMenu === "purchaseAdvanced" && <>
                <PageHeader />
                <DataBox />
                <AdvancedPrint />
            </>}
        </>
    )
}